import React, { Component } from 'react';
import { connect } from 'react-redux';
import './AddMemberModal.css';
import {
  setShowAddMemberModal,
  submitFormRequest,
  updateFormValue,
} from 'actions/admin/work-orders/details/members';
import FormModal from 'components/shared/modal/FormModal';
import Dropdown from 'components/shared/dropdown/Dropdown';
import TextArea from 'components/shared/input/TextArea';
import { getCurrentWorkOrder } from 'selectors/admin/work-orders/work-orders';
import {
  getForm,
  getInvalidFields,
  getShowAddMemberModal,
  getUsers,
  getValidationMessage,
} from 'selectors/admin/work-orders/details/members';
import { getMembers } from 'selectors/admin/work-orders/details/details';
import { getCurrentUser } from 'selectors/authentication';
import { TYPES, usersUtil } from 'services/utils/users-util';

class AddMemberModal extends Component {
  handleClose = () => {
    this.props.dispatch(setShowAddMemberModal(false));
  };

  handleSubmit = (event) => {
    event.preventDefault();
    this.props.dispatch(
      submitFormRequest(this.props.currentWorkOrder.id, this.props.form)
    );
  };

  handleAttributeChange = (attribute, value) => {
    this.props.dispatch(updateFormValue(attribute, value));
  };

  handleUserChange = (option) => {
    const { currentUser, currentWorkOrder, dispatch } = this.props;
    dispatch(updateFormValue('userId', option.value));

    if (usersUtil.hasType(currentUser, TYPES.CONTRACTOR)) {
      // If user is contractor, create a suggested note for the selected new member.
      const suggestedNote = `${
        option.label
      }, you are being added to this Work Order for \
notifications associated with ${currentWorkOrder.client.company_name}, WO #${
        currentWorkOrder.number
      }\
${
  currentWorkOrder.name !== null && currentWorkOrder.name !== ''
    ? ', ' + currentWorkOrder.name
    : ''
}.`;

      dispatch(updateFormValue('note', suggestedNote));
    }
  };

  render() {
    return (
      <FormModal
        className="add-member-modal"
        show={this.props.showAddMemberModal}
        title="Add Member"
        onClose={this.handleClose}
      >
        <div>
          <Dropdown
            disabled={this.props.users.length === 0}
            options={this.props.users
              .filter((user) => this.filterUser(user))
              .map((user) => {
                return {
                  value: user.id,
                  label: `${user.first_name} ${user.last_name}`,
                };
              })}
            placeholder="Which Member would you like to add?"
            valid={
              this.props.invalidFields.find(
                (element) => element === 'userId'
              ) === undefined
            }
            value={this.props.form.userId}
            onChange={this.handleUserChange}
          />
        </div>

        <div>
          <TextArea
            placeholder="Note"
            value={this.props.form.note}
            onChange={this.handleAttributeChange.bind(this, 'note')}
          />
        </div>

        {this.props.validationMessage !== '' && (
          <div className="invalid-message">{this.props.validationMessage}</div>
        )}

        <div className="button-container">
          <input
            type="button"
            className="btn button button-orange"
            value="Continue"
            onClick={this.handleSubmit}
          />
        </div>
      </FormModal>
    );
  }

  filterUser(user) {
    let result = false;

    if (user.status === 'active') {
      // If user is already a member, don't show it
      result =
        this.props.members.filter((member) => member.user.id === user.id)
          .length === 0;
    }

    return result;
  }
}

export default connect((state) => {
  return {
    currentUser: getCurrentUser(state),
    currentWorkOrder: getCurrentWorkOrder(state),
    form: getForm(state),
    invalidFields: getInvalidFields(state),
    members: getMembers(state),
    showAddMemberModal: getShowAddMemberModal(state),
    users: getUsers(state),
    validationMessage: getValidationMessage(state),
  };
})(AddMemberModal);



// WEBPACK FOOTER //
// ./src/components/admin/work-orders/details/members/AddMemberModal.js